import { createAsyncThunk } from '@reduxjs/toolkit';
import { ToppingsCategoryItem } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  FindToppingsCategoryItem,
} from '../../toppingsCategoryItem/api/interface';

export const findSelectToppingsCategoryItemExport = createAsyncThunk(
  'selectToppingsCategoryItem/findSelectToppingsCategoryItemExport',
  async (values: FindToppingsCategoryItem, { rejectWithValue }) => {
    try {
      const response = await ToppingsCategoryItem.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);